<template>
    <div>
        <FileUpload v-if="!selectedImage" :ref="refId" :customUpload="true" :maxFileSize="5000000" :accept="'image/*'" :showUploadButton="false" :showCancelButton="false">
            <template #empty>
                <p>You can either upload an image or select images from below.</p>
            </template>
        </FileUpload>

        <custom-image-selector @image-selected="imageSelected" />
    </div>
</template>

<script>
import CustomImageSelector from '../files/CustomImageSelector.vue';
import useFileComposable from '../../composables/FileComposable';
export default {
    components: { CustomImageSelector },
    props: {
        refId: {
            type: String,
        },
        uploadFile: {
            type: Boolean,
        },
    },
    watch: {
        uploadFile: {
            handler() {
                if (this.uploadFile) {
                    this.uploadFiles();
                }
            },
        },
    },
    setup() {
        const { fileUploader } = useFileComposable();
        return {
            fileUploader,
        };
    },
    data() {
        return {
            selectedImage: null,
        };
    },
    methods: {
        async uploadFiles() {
            if (this.$refs[this.refId].files?.length <= 0) {
                this.$emit('files-empty', true);
            } else {
                const files = this.$refs[this.refId].files;
                const fileIds = await this.fileUploader(files);
                this.$emit('files-uploaded', fileIds);
            }
        },
        async imageSelected(id = null) {
            this.selectedImage = id;
            this.$emit('image-selected', id);
        },
    },
};
</script>
